const PREFIX = 'NAVIGATION_';
export const CHANGE_BREADCRUMB = `${PREFIX}_CHANGE_BREADCRUMB`;
export const changeBreadcrumb = breadcrumb => ({
  type: CHANGE_BREADCRUMB,
  payload: {
    breadcrumb
  }
});
export const cleanBreadcrumb = () => changeBreadcrumb([]);